// AeflorInscricaoManual.jsx
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../../services/api.js";
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer/index.jsx";
import SweetAlert from "react-bootstrap-sweetalert";
import QRCode from "react-qr-code";// usado no modal para renderizar o QR
// Se você já tem folialogo em assets, ajuste o caminho. Se não usar, retire esta importação.
import folialogo from "./../../../public/Images/AEFLORcor.png";


// --- Componente Item de Ingresso ---
const IngressoItem = ({
    ingresso,
    inscrito,
    CadastrarIngresso,
    ConfirmaApagarIngresso,
    toggleTransporte,
    VisualizarIngresso,
}) => {
    const formatNumber = (amount, decimalCount = 2, decimal = ",", thousands = ".") => {
        try {
            decimalCount = Math.abs(decimalCount);
            decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
            const negativeSign = amount < 0 ? "-" : "";
            let i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString();
            let j = i.length > 3 ? i.length % 3 : 0;
            return (
                negativeSign +
                (j ? i.substr(0, j) + thousands : "") +
                i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
                (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "")
            );
        } catch {
            return "0,00";
        }
    };

    const estaInscrito = ingresso.conf !== null;
    const isPrincipal = ingresso.codtipo === 0;

    // Botão padrão (Incluir) ou Excluir (quando inscrito). A lógica visual permanece como antes,
    // mas vamos renderizar Abrir + Excluir quando inscrito, ou Incluir quando não inscrito.
    const transporteIcone =
        ingresso.transporte === "S" ? (
            <i className="fas fa-bus text-primary me-2" title="Transporte Incluído"></i>
        ) : (
            <i className="fas fa-route text-muted me-2" title="Transporte Não Solicitado"></i>
        );

    return (
        <div className={`card mb-3 shadow-sm ${estaInscrito ? "border-success" : "border-light"}`}>
            <div className="card-body p-3">
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <h5 className="card-title mb-1">{ingresso.nome}</h5>
                        <p className={`card-text mb-0 badge ${isPrincipal ? "bg-info" : "bg-warning text-dark"}`}>
                            {isPrincipal ? ingresso.tipo : `${ingresso.tipo} (${ingresso.idade} anos)`}
                        </p>
                    </div>

                    <div className="text-end">
                        <p className="fw-bold mb-0 text-success">R$ {formatNumber(ingresso.valor)}</p>
                        <small className="text-muted">
                            {ingresso.transporte === "S" && estaInscrito && `(+R$ ${formatNumber(ingresso.valort)})`}
                        </small>
                    </div>
                </div>

                <div className="d-flex justify-content-between align-items-center mt-2 pt-2 border-top">
                    <div>
                        {estaInscrito && transporteIcone}
                        <span className={`badge ${estaInscrito ? "bg-success" : "bg-secondary"}`}>
                            {estaInscrito ? "Confirmado" : "Disponível"}
                        </span>
                    </div>

                    <div className="d-flex gap-2">
                        {isPrincipal && (
                            <button
                                type="button"
                                className={`btn btn-sm ${ingresso.transporte === "S" ? "btn-success" : "btn-outline-warning"}`}
                                onClick={() => toggleTransporte(ingresso.transporte === "S" ? "N" : "S")}
                            >
                                {ingresso.transporte === "S" ? (
                                    <>
                                        <i className="fas fa-bus me-1"></i> Ônibus
                                    </>
                                ) : (
                                    <>
                                        <i className="fas fa-plus me-1"></i> Adicionar Transporte
                                    </>
                                )}
                            </button>
                        )}

                        {/* SE NÃO TEM INGRESSO -> INCLUIR */}
                        {!estaInscrito && (
                            <button
                                type="button"
                                onClick={() => CadastrarIngresso(ingresso.codingresso, ingresso.codtipo)}
                                className={`btn btn-sm btn-outline-success pulse`}
                                title="Incluir"
                            >
                                <i className="fas fa-check"></i> Incluir
                            </button>
                        )}

                        {/* SE TEM INGRESSO -> ABRIR + EXCLUIR */}
                        {estaInscrito && (
                            <>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-info"
                                    data-bs-toggle="modal"
                                    data-bs-target="#exampleModal"
                                    onClick={() => VisualizarIngresso(ingresso.codingresso, ingresso.nome)}
                                    title="Abrir Ingresso"
                                >
                                    <i className="fas fa-qrcode me-1"></i> Abrir
                                </button>

                                <button
                                    type="button"
                                    onClick={() => ConfirmaApagarIngresso(ingresso.codingresso, ingresso.nome)}
                                    className="btn btn-sm btn-outline-danger"
                                    title="Excluir Ingresso"
                                >
                                    <i className="fas fa-trash-alt"></i> Excluir
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
// --- Fim Componente Item de Ingresso ---


function AeflorInscricaoManual() {
    const [chapaInput, setChapaInput] = useState("");
    const [chapa, setChapa] = useState(null);
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    const [sucesso, setSucesso] = useState("");
    const [erro, setErro] = useState("");
    const [mensagem, setMensagem] = useState("");
    const [codIngresso, setCodIngresso] = useState("");
    const [nome, setNome] = useState("");
    const [tipo, setTipo] = useState("");
    const [valortransporte, setValorTransporte] = useState(0);
    const [datanascimento, setDataNascimento] = useState("");
    const [somavalor, setSomavalor] = useState(0);
    const [listaIngresso, setListaIngresso] = useState([]);
    const [aprovacao, setAprovacao] = useState(false);
    const [inscrito, setInscrito] = useState(0);
    const navigate = useNavigate();

    // Eventos
    const [eventos, setEventos] = useState([]);
    const [codevento, setCodevento] = useState("");
    const [descricaoEvento, setDescricaoEvento] = useState("");

    // estado para visualizar ingresso (QR/base64)
    const [ingressoValor, setIngressoValor] = useState("000000"); // '000000' = sem ingresso
    const [nomeIngresso, setNomeIngresso] = useState("");

    // Buscar eventos ativos
    useEffect(() => {
        api.get("aeflor/evento/", { params: { matricula: "000000" } })
            .then((response) => {
                const lista = response.data || [];

                // Filtra somente eventos com status "A"
                const eventosAtivos = lista.filter((ev) => ev.status === "A");
                setEventos(eventosAtivos);

                if (eventosAtivos.length > 0) {
                    const evAtivo = eventosAtivos[0];
                    setCodevento(evAtivo.codevento);
                    setDescricaoEvento(evAtivo.nomeevento);
                }
            })
            .catch((err) => {
                setErro("S");
                setMensagem("Erro ao carregar lista de eventos.");
                console.error(err);
            });
    }, []);

    // Selecionar evento ativo
    const handleSelecionarEvento = (e) => {
        const codigo = e.target.value;
        const eventoSelecionado = eventos.find((ev) => ev.codevento === parseInt(codigo));

        if (eventoSelecionado) {
            setCodevento(eventoSelecionado.codevento);
            setDescricaoEvento(eventoSelecionado.nomeevento);
        } else {
            setCodevento("");
            setDescricaoEvento("");
        }
    };

    useEffect(() => {
        if (!codevento) return;
        if (chapa) CarregarDadosIngresso();
        else {
            setListaIngresso([]);
            setIsDataLoaded(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chapa, codevento]);

    const handleBuscar = () => {
        if (!codevento) {
            setErro("S");
            setMensagem("Selecione um evento antes de buscar a chapa.");
            return;
        }
        const trimmedChapa = chapaInput.trim();
        if (!trimmedChapa) {
            setErro("S");
            setMensagem("Por favor, informe o número da CHAPA.");
            return;
        }
        setChapa(trimmedChapa);
    };

    function CarregarDadosIngresso() {
        if (!chapa || !codevento) return;
        api.get(`/aeflor/evento/${codevento}/${chapa}`)
            .then((retorno) => {
                const dados = retorno.data || [];
                const dadosComDependente = dados.map((item) => ({
                    ...item,
                    dependente:
                        item.codtipo === 0
                            ? "FUNCIONARIO"
                            : item.codtipo === 1
                                ? "CADASTRADO"
                                : item.dependente || "MANUAL",
                }));

                setListaIngresso(dadosComDependente);
                setValorTransporte(0);
                setIsDataLoaded(true);

                const listaConfirmada = dadosComDependente.filter((ingresso) => ingresso.conf !== null);
                const somaIngressos = listaConfirmada.reduce((acc, value) => acc + (value.valor || 0), 0);
                setSomavalor(somaIngressos);

                const somaTransporte = listaConfirmada
                    .filter((item) => item.transporte === "S")
                    .reduce((acc, value) => acc + (value.valort || 0), 0);
                setValorTransporte(somaTransporte);

                setInscrito(listaConfirmada.length);
            })
            .catch(() => {
                setIsDataLoaded(true);
                setErro("S");
                setMensagem("Erro ao buscar dados para a chapa informada.");
            });
    }

    function toggleTransporte(opcao) {
        if (!chapa || !codevento) return;
        api.post(`/aeflor/transporte/${codevento}/${chapa}?transporte=${opcao}`)
            .then(() => {
                CarregarDadosIngresso();
                setSucesso("S");
                setMensagem(
                    opcao === "S"
                        ? "Transporte incluído para todos os dependentes! 🚌"
                        : "Transporte removido de todos os dependentes! ❌"
                );
            })
            .catch(() => {
                setErro("S");
                setMensagem("Falha ao alterar o transporte.");
            });
    }

    function CadastrarIngresso(numingresso, tipoIngresso) {
        if (!chapa || !codevento) return;
        let dependenteTipo = tipoIngresso === 0 ? "FUNCIONARIO" : "CADASTRADO";
        api.post(`/aeflor/evento/${codevento}/${chapa}/${numingresso}`, { dependente: dependenteTipo })
            .then(() => {
                CarregarDadosIngresso();
                setSucesso("S");
                setMensagem("Ingresso cadastrado com sucesso! 🎉");
            })
            .catch(() => {
                setErro("S");
                setMensagem("Falha ao cadastrar o ingresso.");
            });
    }

    function ConfirmaApagarIngresso(numingresso, nomepessoa) {
        setAprovacao(true);
        setCodIngresso(numingresso);
        setNome(nomepessoa);
    }

    function ApagarIngresso(numingresso) {
        if (!chapa || !codevento) return;
        api.delete(`/aeflor/evento/${numingresso}`)
            .then(() => {
                CarregarDadosIngresso();
                setSucesso("S");
                setAprovacao(false);
                setMensagem("Ingresso excluído com sucesso! 🗑️");
            })
            .catch(() => {
                setErro("S");
                setAprovacao(false);
                setMensagem("Falha ao excluir o ingresso.");
            });
    }

    function zerarcampos() {
        setNome("");
        setTipo("");
        setDataNascimento("");
    }

    function CadastrarDependente() {
        if (!chapa || !codevento) return;

        if (!tipo || !nome || !datanascimento) {
            setErro("S");
            setMensagem("É necessário informar o nome, parentesco e data de nascimento do dependente!");
            return;
        }

        const data = {
            codevento,
            chapa,
            nome,
            tipo,
            datanascimento,
            dependente: "MANUAL",
        };

        api.post(`/aeflor/evento/${codevento}/${chapa}/DEPENDENTE`, data)
            .then(() => {
                CarregarDadosIngresso();
                setSucesso("S");
                setMensagem("Dependente cadastrado com sucesso! ✅");
                zerarcampos();
            })
            .catch(() => {
                setErro("S");
                setMensagem("Falha no envio do dependente!");
            });
    }

    // ---------- AÇÃO: Visualizar / Abrir Ingresso (sua função original) ----------
    function VisualizarIngresso(num, nomePessoa) {
        setIngressoValor("000000");
        // Usa storedCodevento (do localStorage)
        const storedCodevento = localStorage.getItem("storedCodevento") || codevento;
        api.get('/aeflor/evento/' + storedCodevento + '/' + chapa + '/' + num)
            .then(async (retorno) => {
                await setIngressoValor(retorno.data.resultado);
                setNomeIngresso(nomePessoa);
            })
            .catch(err => {
                console.log(err);
            });
    }

    /* -----------------------------------------------------
       RENDER
    ------------------------------------------------------ */
    return (
        <>
            <Menu modulo="AEFLOR" />
            <div className="container mt-5">
                <div className="row justify-content-center">
                    <div className="col-lg-8 mx-auto">
                        <div className="card shadow-lg border-0">
                            <div className="card-header bg-danger text-white text-center p-3">
                                <h3 className="mb-0">Inscrições Manual 🎉</h3>
                                <p className="mb-0 small text-white">
                                    <i>Insira a chapa para iniciar as inscrições.</i>
                                </p>
                            </div>
                            <div className="card-body p-4">
                                {/* SELEÇÃO DE EVENTO */}
                                <div className="mb-4">
                                    <label className="form-label fw-bold">Selecione o Evento:</label>
                                    <select
                                        className="form-select form-select-lg"
                                        value={codevento}
                                        onChange={handleSelecionarEvento}
                                    >
                                        <option value="">-- Escolha o evento ativo --</option>
                                        {eventos.map((ev) => (
                                            <option key={ev.codevento} value={ev.codevento}>
                                                {ev.nomeevento}
                                            </option>
                                        ))}
                                    </select>
                                    {descricaoEvento && (
                                        <div className="mt-2 text-muted small">
                                            <i className="fas fa-info-circle me-1"></i>
                                            Evento selecionado: <b>{descricaoEvento}</b>
                                        </div>
                                    )}
                                </div>

                                {/* BUSCA CHAPA */}
                                <div className="row g-2 mb-4">
                                    <div className="col-9">
                                        <input
                                            type="text"
                                            className="form-control form-control-lg"
                                            placeholder="Digite o número da CHAPA"
                                            value={chapaInput}
                                            onChange={(e) => setChapaInput(e.target.value)}
                                            onKeyPress={(e) => e.key === "Enter" && handleBuscar()}
                                        />
                                    </div>
                                    <div className="col-3">
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-lg w-100"
                                            onClick={handleBuscar}
                                        >
                                            <i className="fas fa-search me-1"></i> Buscar
                                        </button>
                                    </div>
                                    {chapa && (
                                        <div className="col-12 mt-2">
                                            <span className="badge bg-secondary">
                                                Chapa Ativa: <b>{chapa}</b>
                                            </span>
                                        </div>
                                    )}
                                </div>

                                {/* LISTAGEM */}
                                {chapa && isDataLoaded ? (
                                    <>
                                        <div className="list-group">
                                            {listaIngresso.length > 0 ? (
                                                listaIngresso.map((ingresso) => (
                                                    <IngressoItem
                                                        key={ingresso.codingresso}
                                                        ingresso={ingresso}
                                                        inscrito={inscrito}
                                                        CadastrarIngresso={CadastrarIngresso}
                                                        ConfirmaApagarIngresso={ConfirmaApagarIngresso}
                                                        toggleTransporte={toggleTransporte}
                                                        VisualizarIngresso={VisualizarIngresso}
                                                    />
                                                ))
                                            ) : (
                                                <div className="alert alert-info text-center">
                                                    Nenhum ingresso encontrado para a chapa <b>{chapa}</b>. 😔
                                                </div>
                                            )}
                                        </div>

                                        <hr className="my-4" />

                                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
                                            {inscrito > 0 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-outline-primary mb-2 mb-md-0 me-md-auto"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#modalDependente"
                                                    onClick={zerarcampos}
                                                >
                                                    <i className="fas fa-user-plus me-1"></i> Adicionar Não Cadastrado
                                                </button>
                                            )}

                                            <Link
                                                to={"/arbor/aeflor/"}
                                                className="btn btn-lg btn-success d-flex align-items-center justify-content-center"
                                            >
                                                Finalizar
                                                <span className="badge bg-light text-success ms-2 p-2 fs-6">
                                                    R$ {somavalor.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
                                                </span>
                                            </Link>
                                        </div>

                                        {valortransporte > 0 && inscrito > 0 && (
                                            <div className="text-end mt-2">
                                                <small className="text-muted fw-bold">
                                                    Transporte incluído: R${" "}
                                                    {valortransporte.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
                                                </small>
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    chapa && (
                                        <div className="text-center text-muted">
                                            <div className="spinner-border text-danger mb-3" role="status"></div>
                                            <p>Carregando ingressos...</p>
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* -------------------- MODAL DE VISUALIZAÇÃO (EXAMPLEMODAL) -------------------- */}
                    {/* */}
        <div className="modal fade" id="exampleModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <img className="text-center foto-top fa-blink" src={folialogo} />
                    <div className="alterafoto">
                        <QRCode className="text-center fotoPerfil"
                            value={ingressoValor} />
                    </div>
                    <div>
                        <label className="font-espaco"><i className="fa fa-user" aria-hidden="true"></i> {nome}</label>
                    </div>
                </div>
            </div>
        </div>
        {/* */}

            {/* MODAL DEPENDENTE */}
            <div className="modal fade" id="modalDependente" tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-primary text-white">
                            <h5 className="modal-title">Cadastrar Dependente Manualmente</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group mb-3">
                                <label className="fw-bold">Nome:</label>
                                <input type="text" className="form-control" value={nome} onChange={(e) => setNome(e.target.value)} />
                            </div>
                            <div className="form-group mb-3">
                                <label className="fw-bold">Parentesco:</label>
                                <select className="form-select" value={tipo} onChange={(e) => setTipo(e.target.value)}>
                                    <option value="">Selecione...</option>
                                    <option value="FILHO">Filho(a)</option>
                                    <option value="CONJUGE">Cônjuge</option>
                                    <option value="OUTRO">Outro</option>
                                </select>
                            </div>
                            <div className="form-group mb-3">
                                <label className="fw-bold">Data de Nascimento:</label>
                                <input type="date" className="form-control" value={datanascimento} onChange={(e) => setDataNascimento(e.target.value)} />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                Fechar
                            </button>
                            <button type="button" className="btn btn-success" onClick={CadastrarDependente}>
                                Salvar
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* ALERTAS */}
            {aprovacao && (
                <SweetAlert
                    warning
                    showCancel
                    confirmBtnText="Sim, excluir!"
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="default"
                    title="Confirma exclusão?"
                    onConfirm={() => ApagarIngresso(codIngresso)}
                    onCancel={() => setAprovacao(false)}
                >
                    Deseja realmente excluir o ingresso de <b>{nome}</b>?
                </SweetAlert>
            )}

            {sucesso && (
                <SweetAlert success title="Sucesso!" onConfirm={() => setSucesso("")}>
                    {mensagem}
                </SweetAlert>
            )}

            {erro && (
                <SweetAlert error title="Erro!" onConfirm={() => setErro("")}>
                    {mensagem}
                </SweetAlert>
            )}

            <Footer />
        </>
    );
}

export default AeflorInscricaoManual;
